import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import { changeLanguage, saveUser } from '../../modules/user';

import WellMessage from '../../components/Wellcome/WellMessage';

import { recordPageGA } from '../../modules/ga';
import { getMobileOperatingSystem } from '../../utils';
import './index.less';

const isApple = (getMobileOperatingSystem() == 'iOS') ? true : false;

const Wellcome = ({ lang, changeLanguage }) => {
  const [tempUser, setTempUser] = React.useState(null);

  React.useEffect(() => {
    window.scrollTo(0, 0);
    recordPageGA('/welcome');
  }, []);

  const handleChangeLanguage = (language) => {
    console.log('handleChangeLanguage:', language);
    changeLanguage(language);
  }

  return <div className={`MiSoroban welcome ${isApple ? 'apple-welcome' : ''}`} >
    <WellMessage lang={lang} onChangeLanguage={handleChangeLanguage} />
  </div>;
}

const mapStateToProps = ({ user }) => ({
  lang: user.lang,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeLanguage,
      saveUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Wellcome);
